import RHFDictionary from '../RHFDictionary';
import { useProductBrand } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'description',
    label: 'Name',
    align: 'left',
    nameLines: 2,
    subNameLines: 1,
    minWidth: 180,
    width: 280,
    maxWidth: 360,
  },
];

type RHFProductBrandProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFProductBrand({
  name,
  label = 'Brand',
  multiple = false,
  disabled,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFProductBrandProps) {
  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useProductBrand}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={{}}
      drawerWidth={drawerWidth}
    />
  );
}
